import _ from 'lodash';
import ResponseList from './ResponseList';
import { defineComponent, h } from 'vue';
import { INSPECTION_ITEM_RESPONSE } from '@/_legacy/constants';
import { t } from '@/ui/i18n/i18n';
import { parseNumber } from '@/_legacy/services/inspection';

export default defineComponent({
  name: 'Responses',
  props: ['uuid', 'count', 'label', 'questionSet', 'responseSet', 'responseType'],
  setup(props) {
    const sumResponseNumber = respondedQuestions =>
      respondedQuestions.reduce((accumulator, current) => accumulator + parseNumber(current.response), 0);

    return function render() {
      const respondedQuestions = _.filter(
        props.questionSet.questions,
        question => question.response !== null,
      );
      const count = _.sumBy(respondedQuestions, 'count');

      return h('div', [
        h('h6', {
          class: ['mb-3'],
        }, props.label),
        h('div', { class: ['flex', 'justify-between'] }, [
          h('span', {
            class: ['text-60', 'mb-2'],
          }, t('analytics.responses', { nResponses: count }, count)),
          props.responseType === INSPECTION_ITEM_RESPONSE.NUMBER
          && h('span', {
            class: ['text-60', 'mb-2'],
          }, `${t('Total')}: ${sumResponseNumber(respondedQuestions)}`),
        ]),
        h(ResponseList, {
          props: {
            questionSet: respondedQuestions,
          },
        }),
      ]);
    };
  }
});
